import React from 'react'

import { createSvgIcon } from './utils/create-svg-icon'

export const CircleWarningIcon = createSvgIcon(
  <>
    <title>circle warning</title>
    <g
      className="nc-icon-wrapper"
      fill="#222222"
      stroke="#222222"
      strokeLinecap="square"
      strokeLinejoin="miter"
      strokeWidth="1"
      transform="translate(0.5 0.5)"
    >
      <circle
        cx="16"
        cy="16"
        fill="none"
        r="15"
        stroke="#222222"
        strokeMiterlimit="10"
      />{' '}
      <line
        data-color="color-2"
        fill="none"
        strokeMiterlimit="10"
        x1="16"
        x2="16"
        y1="7"
        y2="19"
      />{' '}
      <circle
        cx="16"
        cy="24.5"
        data-color="color-2"
        data-stroke="none"
        r="1.5"
        stroke="none"
      />
    </g>
  </>
)
